import Modal, { destroyFns } from './Modal';
import confirm, {
    withInfo,
    withConfirm,
} from './confirm';

Modal.info = (props) => {
    return confirm(withInfo(props));
};

Modal.confirm = (props) => {
    return confirm(withConfirm(props));
};

Modal.destroyAll = function destroyAllFn() {
    while (destroyFns.length) {
        const close = destroyFns.pop();
        if (close) {
            close();
        }
    }
};

export default Modal;